import { useMemo } from 'react';
import { DetailForm } from 'xui-pro';
import { useTranslation } from '@/hooks/useTranslation';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/models/store';
import styles from './index.module.less';

type VehicleInfoProps = {
  vin?: string;
  modelCodeName?: string;
  seriesCodeName?: string;
};

const VehicleInfo = (props: VehicleInfoProps) => {
  const $ = useTranslation();
  const isGlobal = useSelector<RootState>(state => state.LocaleModel.isGlobal, shallowEqual);

  const formItems = useMemo(() => {
    return [
      {
        label: $('VIN码'),
        type: 'input',
        name: 'vin',
        hidden: props.vin ? false : true,
        initialValue: props.vin
      },
      {
        label: isGlobal ? $('车系车型') : $('车系'),
        type: 'input',
        render: () =>
          isGlobal ? `${props.seriesCodeName} ${props.modelCodeName}` : `${props.seriesCodeName}`
      }
    ].filter(item => !item.hidden);
  }, [$, props, isGlobal]);

  return (
    <DetailForm
      formItems={formItems}
      readonly={true}
      labelAlign='top'
      span={24}
      emptyPlaceholder='-'
      hasEmptyPlaceholder={true}
      className={styles.vehicleInfo}
    />
  );
};

export default VehicleInfo;
